// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://rsms.me/inter/inter.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Main wrapper
 */
.select-search-container {
    --select-search-background: #fff;
    --select-search-border: #dce0e8;
    --select-search-selected: #1e66f5;
    --select-search-text: #000;
    --select-search-subtle-text: #6c6f85;
    --select-search-inverted-text: var(--select-search-background);
    --select-search-highlight: #eff1f5;
    --select-search-font: 'Inter', sans-serif;

    width: 300px;
    position: relative;
    font-family: var(--select-search-font);
    color: var(--select-search-text);
    box-sizing: border-box;
}

@supports (font-variation-settings: normal) {
    .select-search-container {
        --select-search-font: 'Inter var', sans-serif;
    }
}

@media (prefers-color-scheme: dark) {
    .select-search-container {
        --select-search-background: #000;
        --select-search-border: #313244;
        --select-search-selected: #89b4fa;
        --select-search-text: #fff;
        --select-search-subtle-text: #a6adc8;
        --select-search-highlight: #1e1e2e;
    }
}

body.is-dark-mode .select-search-container {
    --select-search-background: #000;
    --select-search-border: #313244;
    --select-search-selected: #89b4fa;
    --select-search-text: #fff;
    --select-search-subtle-text: #a6adc8;
    --select-search-highlight: #1e1e2e;
}

body.is-light-mode .select-search-container {
    --select-search-background: #fff;
    --select-search-border: #dce0e8;
    --select-search-selected: #1e66f5;
    --select-search-text: #000;
    --select-search-subtle-text: #6c6f85;
    --select-search-highlight: #eff1f5;
}

.select-search-container *,
.select-search-container *::after,
.select-search-container *::before {
    box-sizing: inherit;
}

.select-search-input {
    position: relative;
    z-index: 1;
    display: block;
    height: 48px;
    width: 100%;
    padding: 0 40px 0 16px;
    background: var(--select-search-background);
    border: 2px solid var(--select-search-border);
    color: var(--select-search-text);
    border-radius: 3px;
    outline: none;
    font-family: var(--select-search-font);
    font-size: 16px;
    text-align: left;
    text-overflow: ellipsis;
    line-height: 48px;
    letter-spacing: 0.01rem;
    -webkit-appearance: none;
    -webkit-font-smoothing: antialiased;
}

.select-search-is-multiple .select-search-input {
    margin-bottom: -2px;
}

.select-search-is-multiple .select-search-input {
    border-radius: 3px 3px 0 0;
}

.select-search-input::-webkit-search-decoration,
.select-search-input::-webkit-search-cancel-button,
.select-search-input::-webkit-search-results-button,
.select-search-input::-webkit-search-results-decoration {
    -webkit-appearance:none;
}

.select-search-input[readonly] {
    cursor: pointer;
}

.select-search-is-disabled .select-search-input {
    cursor: not-allowed;
}

.select-search-container:not(.select-search-is-disabled).select-search-has-focus .select-search-input,
.select-search-container:not(.select-search-is-disabled) .select-search-input:hover {
    border-color: var(--select-search-selected);
}

.select-search-select {
    background: var(--select-search-background);
    box-shadow: 0 .0625rem .125rem rgba(0, 0, 0, 0.15);
    border: 2px solid var(--select-search-border);
    overflow: auto;
    max-height: 360px;
}

.select-search-container:not(.select-search-is-multiple) .select-search-select {
    position: absolute;
    z-index: 2;
    top: 58px;
    right: 0;
    left: 0;
    border-radius: 3px;
    display: none;
}

.select-search-container:not(.select-search-is-multiple).select-search-has-focus .select-search-select {
    display: block;
}

.select-search-has-focus .select-search-select {
    border-color: var(--select-search-selected);
}

.select-search-options {
    list-style: none;
}

.select-search-option,
.select-search-not-found {
    display: block;
    height: 42px;
    width: 100%;
    padding: 0 16px;
    background: var(--select-search-background);
    border: none;
    outline: none;
    font-family: var(--select-search-font);
    color: var(--select-search-text);
    font-size: 16px;
    text-align: left;
    letter-spacing: 0.01rem;
    cursor: pointer;
    -webkit-font-smoothing: antialiased;
}

.select-search-option:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: transparent !important;
}

.select-search-is-highlighted,
.select-search-option:not(.select-search-is-selected):hover {
    background: var(--select-search-highlight);
}

.select-search-is-selected {
    font-weight: bold;
    color: var(--select-search-selected);
}

.select-search-group-header {
    font-size: 12px;
    text-transform: uppercase;
    background: var(--select-search-border);
    color: var(--select-search-subtle-text);
    letter-spacing: 0.1rem;
    padding: 10px 16px;
}

.select-search-row:not(:first-child) .select-search-group-header {
    margin-top: 10px;
}

.select-search-row:not(:last-child) .select-search-group-header {
    margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-select-search/style.css"],"names":[],"mappings":"AAEA;;EAEE;AACF;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,iCAAiC;IACjC,0BAA0B;IAC1B,oCAAoC;IACpC,8DAA8D;IAC9D,kCAAkC;IAClC,yCAAyC;;IAEzC,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI;QACI,6CAA6C;IACjD;AACJ;;AAEA;IACI;QACI,gCAAgC;QAChC,+BAA+B;QAC/B,iCAAiC;QACjC,0BAA0B;QAC1B,oCAAoC;QACpC,kCAAkC;IACtC;AACJ;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,iCAAiC;IACjC,0BAA0B;IAC1B,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,iCAAiC;IACjC,0BAA0B;IAC1B,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,2CAA2C;IAC3C,6CAA6C;IAC7C,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;;IAII,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,kDAAkD;IAClD,6CAA6C;IAC7C,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;IACR,OAAO;IACP,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,uCAAuC;IACvC,uCAAuC;IACvC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["@import url('https://rsms.me/inter/inter.css');\n\n/**\n * Main wrapper\n */\n.select-search-container {\n    --select-search-background: #fff;\n    --select-search-border: #dce0e8;\n    --select-search-selected: #1e66f5;\n    --select-search-text: #000;\n    --select-search-subtle-text: #6c6f85;\n    --select-search-inverted-text: var(--select-search-background);\n    --select-search-highlight: #eff1f5;\n    --select-search-font: 'Inter', sans-serif;\n\n    width: 300px;\n    position: relative;\n    font-family: var(--select-search-font);\n    color: var(--select-search-text);\n    box-sizing: border-box;\n}\n\n@supports (font-variation-settings: normal) {\n    .select-search-container {\n        --select-search-font: 'Inter var', sans-serif;\n    }\n}\n\n@media (prefers-color-scheme: dark) {\n    .select-search-container {\n        --select-search-background: #000;\n        --select-search-border: #313244;\n        --select-search-selected: #89b4fa;\n        --select-search-text: #fff;\n        --select-search-subtle-text: #a6adc8;\n        --select-search-highlight: #1e1e2e;\n    }\n}\n\nbody.is-dark-mode .select-search-container {\n    --select-search-background: #000;\n    --select-search-border: #313244;\n    --select-search-selected: #89b4fa;\n    --select-search-text: #fff;\n    --select-search-subtle-text: #a6adc8;\n    --select-search-highlight: #1e1e2e;\n}\n\nbody.is-light-mode .select-search-container {\n    --select-search-background: #fff;\n    --select-search-border: #dce0e8;\n    --select-search-selected: #1e66f5;\n    --select-search-text: #000;\n    --select-search-subtle-text: #6c6f85;\n    --select-search-highlight: #eff1f5;\n}\n\n.select-search-container *,\n.select-search-container *::after,\n.select-search-container *::before {\n    box-sizing: inherit;\n}\n\n.select-search-input {\n    position: relative;\n    z-index: 1;\n    display: block;\n    height: 48px;\n    width: 100%;\n    padding: 0 40px 0 16px;\n    background: var(--select-search-background);\n    border: 2px solid var(--select-search-border);\n    color: var(--select-search-text);\n    border-radius: 3px;\n    outline: none;\n    font-family: var(--select-search-font);\n    font-size: 16px;\n    text-align: left;\n    text-overflow: ellipsis;\n    line-height: 48px;\n    letter-spacing: 0.01rem;\n    -webkit-appearance: none;\n    -webkit-font-smoothing: antialiased;\n}\n\n.select-search-is-multiple .select-search-input {\n    margin-bottom: -2px;\n}\n\n.select-search-is-multiple .select-search-input {\n    border-radius: 3px 3px 0 0;\n}\n\n.select-search-input::-webkit-search-decoration,\n.select-search-input::-webkit-search-cancel-button,\n.select-search-input::-webkit-search-results-button,\n.select-search-input::-webkit-search-results-decoration {\n    -webkit-appearance:none;\n}\n\n.select-search-input[readonly] {\n    cursor: pointer;\n}\n\n.select-search-is-disabled .select-search-input {\n    cursor: not-allowed;\n}\n\n.select-search-container:not(.select-search-is-disabled).select-search-has-focus .select-search-input,\n.select-search-container:not(.select-search-is-disabled) .select-search-input:hover {\n    border-color: var(--select-search-selected);\n}\n\n.select-search-select {\n    background: var(--select-search-background);\n    box-shadow: 0 .0625rem .125rem rgba(0, 0, 0, 0.15);\n    border: 2px solid var(--select-search-border);\n    overflow: auto;\n    max-height: 360px;\n}\n\n.select-search-container:not(.select-search-is-multiple) .select-search-select {\n    position: absolute;\n    z-index: 2;\n    top: 58px;\n    right: 0;\n    left: 0;\n    border-radius: 3px;\n    display: none;\n}\n\n.select-search-container:not(.select-search-is-multiple).select-search-has-focus .select-search-select {\n    display: block;\n}\n\n.select-search-has-focus .select-search-select {\n    border-color: var(--select-search-selected);\n}\n\n.select-search-options {\n    list-style: none;\n}\n\n.select-search-option,\n.select-search-not-found {\n    display: block;\n    height: 42px;\n    width: 100%;\n    padding: 0 16px;\n    background: var(--select-search-background);\n    border: none;\n    outline: none;\n    font-family: var(--select-search-font);\n    color: var(--select-search-text);\n    font-size: 16px;\n    text-align: left;\n    letter-spacing: 0.01rem;\n    cursor: pointer;\n    -webkit-font-smoothing: antialiased;\n}\n\n.select-search-option:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background: transparent !important;\n}\n\n.select-search-is-highlighted,\n.select-search-option:not(.select-search-is-selected):hover {\n    background: var(--select-search-highlight);\n}\n\n.select-search-is-selected {\n    font-weight: bold;\n    color: var(--select-search-selected);\n}\n\n.select-search-group-header {\n    font-size: 12px;\n    text-transform: uppercase;\n    background: var(--select-search-border);\n    color: var(--select-search-subtle-text);\n    letter-spacing: 0.1rem;\n    padding: 10px 16px;\n}\n\n.select-search-row:not(:first-child) .select-search-group-header {\n    margin-top: 10px;\n}\n\n.select-search-row:not(:last-child) .select-search-group-header {\n    margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
